import type { QuestDef } from './types'
import { POST_NORMAL_RECOLLECTION } from '../utils/constants'

export const QUESTS: Record<string, QuestDef> = {
  QST_001: {
    id: 'QST_001',
    name: '盛典之日',
    description: '参加木桶镇的二十年一度盛典，预言之书将揭示命运。',
    objectives: ['与慧慧对话', '前往会场', '参加盛典'],
    rewards: [{ exp: 50, flag: 'ring_awakened', value: true }],
  },
  QST_002: {
    id: 'QST_002',
    name: '整理菜园子',
    description: '去小镇西南角的菜园，帮菠萝大叔整理篱笆里的菜地。',
    objectives: ['与菠萝大叔对话', '清理菜园木桶', '向菠萝大叔汇报'],
    rewards: [{ exp: 30 }],
  },
  QST_003: {
    id: 'QST_003',
    name: '镇长的嘱托',
    description: '镇长在会场北侧的镇长家门口等你，将父亲的遗物和预言之书交给你。',
    objectives: ['前往会场北侧的镇长家门口', '接受嘱托', '获得预言之书'],
    rewards: [{ exp: 50 }],
  },
  QST_004: {
    id: 'QST_004',
    name: '奇妙森林',
    description: '前往奇妙森林寻找千年树种。',
    objectives: ['离开木桶镇', '穿越奇妙森林', '找到千年树种'],
    rewards: [{ exp: 100 }],
  },
  QST_005: {
    id: 'QST_005',
    name: '白虎的试炼',
    description: '在奇妙森林围湖接受白虎的试炼。',
    objectives: ['前往围湖', '通过白虎试炼', '获得白虎传承'],
    rewards: [{ exp: 150 }],
  },
  QST_006: {
    id: 'QST_006',
    name: '圣水殿',
    description: '前往圣水殿取得神水。',
    objectives: ['乘船前往圣水殿', '击败水瑶和风赤', '通过熙苑的问答'],
    rewards: [{ exp: 200 }],
  },
  QST_007: {
    id: 'QST_007',
    name: '神殿之路',
    description: '前往神殿取得神之桂冠。',
    objectives: ['穿越神殿山路', '通过七色路试炼', '击败凤凰与麒麟'],
    rewards: [{ exp: 250 }],
  },
  QST_008: {
    id: 'QST_008',
    name: '重建木桶镇',
    description: '集齐三件神物，重建木桶镇。',
    objectives: ['带回千年树种', '带回神水', '带回神之桂冠'],
    rewards: [{ rebuild: 3, exp: 300 }],
  },
  QST_009: {
    id: 'QST_009',
    name: '生命之泉',
    description: '前往生命之泉寻找 xiaoai 的真相。',
    objectives: ['抵达生命之泉入口', '突破气壁', '释放祀神四体'],
    rewards: [{ exp: 400 }],
  },
  QST_010: {
    id: 'QST_010',
    name: '四封印',
    description: '击败魑魅魍魉，释放祀神四体。',
    objectives: ['击败魑（青龙潭）', '击败魅（白虎穴）', '击败魍（朱雀林）', '击败魉（玄武殿）'],
    objectiveFlags: ['seal_qinglong_released', 'seal_baihu_released', 'seal_zhuque_released', 'seal_xuanwu_released'],
    rewards: [{ exp: 500 }],
  },
  QST_011: {
    id: 'QST_011',
    name: '轮回道',
    description: '通过轮回道，了解 xiaoai 的过去。',
    objectives: ['集齐四碑牌', '进入轮回道', '完成关键对白'],
    rewards: [{ exp: 300 }],
  },
  QST_012: {
    id: 'QST_012',
    name: '魔宫决战',
    description: '前往魔宫救出 A，面对 xiaoai。',
    objectives: ['前往魔宫', '通过黑暗沼泽', '击败 xiaoai'],
    rewards: [{ exp: 600 }],
  },
  QST_013: {
    id: 'QST_013',
    name: '人心之渊',
    description: '进入人心之渊，面对真正的黑暗——无相。',
    objectives: ['进入人心之渊', '击败五心影', '击败无相'],
    rewards: [{ exp: 1000 }],
  },
  QST_014: {
    id: 'QST_014',
    name: '蓝色薄荷',
    description: '帮助药草商采集森林深处的蓝色薄荷',
    objectives: ['前往奇妙森林采集蓝色薄荷', '把蓝色薄荷交给药草商'],
    rewards: [{ exp: 50, itemId: 'heal_grass', itemQty: 5 }],
  },
  [POST_NORMAL_RECOLLECTION.QUEST_ID]: {
    id: POST_NORMAL_RECOLLECTION.QUEST_ID,
    name: '残光回溯',
    description: '在重建镇的生命之泉旁，面对普通结局留下的遗憾与残光。',
    objectives: ['触碰残光，完成回溯与补偿仪式'],
    rewards: [{ exp: 500 }],
  },
}
